import { IClientInfo } from '../../../models';

export const titles: Array<keyof IClientInfo> = [
	'employeesCount',
	'locationCount',
	'domainCount',
	'officeCount',
];
